// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3SPkM","gfeWrapper":"CalendarEvent_gfeWrapper__2N2cQ"};